import { Component } from 'react';

import CollapsableSelectListItem from 'components/molecules/collapsableSelectListItem';
import CollapsableSelectListItemHeader from 'components/atoms/collapsableSelectListItemHeader';

export default class ExplainedCheckbox extends Component {
  handleOnClick() {
    if (!this.props.input) {
      return;
    }

    const {
      fieldValue,
      append,
      input: { value, onChange },
    } = this.props;

    let { toggleValue } = this.props;

    let newValue;

    if (append) {
      let newValue = value || [];
      let index = newValue.indexOf(fieldValue);

      if (index >= 0) {
        newValue.splice(index, 0);
      } else {
        newValue.push(fieldValue);
      }
    } else {
      newValue = fieldValue === value ? toggleValue : fieldValue;
    }

    onChange(newValue);
  }

  render() {
    const { fieldValue, input, helpText, title, secondaryInfo, append } = this.props;

    let checked = append
      ? input.value.indexOf(fieldValue) >= 0
      : input && input.value === fieldValue
      ? true
      : false;

    return (
      <CollapsableSelectListItem onClick={this.handleOnClick.bind(this)}>
        <CollapsableSelectListItemHeader
          secondaryInfo={secondaryInfo}
          helpText={helpText}
          title={title}
          checked={checked}
        />
      </CollapsableSelectListItem>
    );
  }
}
